import React, { useEffect, useState } from 'react';
import { useAssessmentsQuery } from 'src/graphql/_generated';
import useLocalStorage from 'src/hooks/useLocalStorage';

const useSelectedAssessment = () => {
  const [selectedAssessmentStored, setSelectedAssessmentStored] = useLocalStorage('insights_assessment', '');
  const [selectedAssessment, setSelectedAssessment] = useState('');

  const { data, error } = useAssessmentsQuery();

  useEffect(() => {
    const isValidSelectedAssessmentStored = data?.assessments.some((a) => a.id === selectedAssessmentStored);
    if (isValidSelectedAssessmentStored) {
      setSelectedAssessment(selectedAssessmentStored);
    } else {
      setSelectedAssessmentStored(data?.assessments[0]?.id || '');
    }
  }, [data, selectedAssessmentStored]);

  useEffect(() => {
    if (error) {
      setSelectedAssessmentStored('');
    }
  }, [error]);

  return { setSelectedAssessmentStored, selectedAssessment };
};

export default useSelectedAssessment;
